/**
 * @deprecated This Redux slice is partially deprecated.
 * It uses RTK Query matchers for the mapApi but maintains local state.
 *
 * Consider migrating to use RTK Query hooks directly:
 * - Import from: `redux/services/map/mapApi`
 * - Queries: `useGetDistanceQuery`
 *
 * This slice demonstrates a hybrid migration pattern and will be
 * fully removed in future versions.
 */
import { createSlice } from "@reduxjs/toolkit";
import { mapApi } from "../services/map/mapApi";

const initialState = {
  map: {},
  status: "idle",
  error: null,
};

// getDistance thunk migrated to RTK Query (services/map/mapApi)

export const mapSlice = createSlice({
  name: "map",
  initialState,
  reducers: {
    resetMap: () => initialState,
  },
  extraReducers(builder) {
    builder
      .addMatcher(
        mapApi.endpoints.getDistance.matchPending,
        (state, action) => {
          state.status = "loading";
        }
      )
      .addMatcher(
        mapApi.endpoints.getDistance.matchFulfilled,
        (state, action) => {
          state.map = {};
          state.status = "succeeded";
          state.map = action.payload;
        }
      )
      .addMatcher(
        mapApi.endpoints.getDistance.matchRejected,
        (state, action) => {
          state.status = "failed";
          state.error = action.error?.message;
        }
      );
  },
});

export const { resetMap } = mapSlice.actions;

export default mapSlice.reducer;
